/*import "bootstrap/dist/css/bootstrap.min.css";*/
import "./css/main-custom.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./fonts/fontawesome-all.min.css";
import "./fonts/ionicons.min.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { AuthProvider } from "react-oidc-context";
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

import App from "./App";
import "./i18n";
import configureStore from "./store/configureStore";
import { ConfigProvider } from "ConfigContext";

import "./css/custom.css";
import { oidcConfig } from "./util/keycloak/config";
import { MantineProvider } from "@mantine/core";



const baseUrl = document.getElementsByTagName("base")[0]?.getAttribute("href") ?? "/";
const rootElement = document.getElementById("root");

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    const store = configureStore();
    const persistor = persistStore(store);

    root.render(
        <React.StrictMode>
            <ConfigProvider>
                <ReduxProvider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <BrowserRouter basename={baseUrl}>
                            <React.Suspense fallback="">
                                <MantineProvider>
                                    <App />
                                </MantineProvider>
                            </React.Suspense>
                        </BrowserRouter>
                    </PersistGate>
                </ReduxProvider>
            </ConfigProvider>
        </React.StrictMode>
    );
} else {
    console.error("Root element not found");
}
